import { NotificationsState } from '../state/notifications.state';
import { AppState } from '../state';

export const selectNotifications = (state: AppState): NotificationsState =>
    state.notifications;
